export default __webpack_public_path__ + "static/media/membership2.a2965bdf.jpg";